import React, { useEffect } from "react";

const SupportSuccessScreen = ({ theme, onContinue }) => {
  const isDark = theme === "dark";
  const colors = {
    background: isDark ? "#0F172A" : "#F8FBFA",
    surface: isDark ? "#1E293B" : "#FFFFFF",
    text: isDark ? "#F1F5F9" : "#1E293B",
    secondaryText: isDark ? "#94A3B8" : "#64748B",
    accent: "#14B8A6",
    border: isDark ? "rgba(20, 184, 166, 0.2)" : "rgba(20, 184, 166, 0.1)"
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      // 1. Cleanup URL immediately while component is still mounted
      window.history.replaceState({}, "", "/");
      
      // 2. Tiny delay to ensure history commits before React unmounts us
      setTimeout(() => {
        onContinue();
      }, 50);
    }, 1800);
    return () => clearTimeout(timer);
  }, [onContinue]);

  return (
    <div style={{
      width: "100%",
      height: "100dvh",
      background: colors.background,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      textAlign: "center",
      boxSizing: "border-box",
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Background Decor */}
      <div style={{
        position: "absolute",
        top: "-10%",
        right: "-10%",
        width: "300px",
        height: "300px",
        background: `radial-gradient(circle, ${colors.accent}15 0%, transparent 70%)`,
        borderRadius: "50%",
        filter: "blur(40px)"
      }} />
      <div style={{
        position: "absolute",
        bottom: "-10%",
        left: "-10%",
        width: "300px",
        height: "300px",
        background: `radial-gradient(circle, ${colors.accent}10 0%, transparent 70%)`,
        borderRadius: "50%",
        filter: "blur(40px)"
      }} />

      <div style={{
        background: colors.surface,
        borderRadius: "32px",
        padding: "40px 24px",
        width: "100%",
        maxWidth: "400px",
        boxShadow: isDark ? "0 20px 50px rgba(0,0,0,0.3)" : "0 10px 30px rgba(0,0,0,0.05)",
        border: `1px solid ${colors.border}`,
        position: "relative",
        zIndex: 1
      }}>
        <div style={{ fontSize: "64px", marginBottom: "20px", animation: "bounce 2s infinite" }}>☕</div>
        <h1 style={{ fontSize: "24px", fontWeight: "900", color: colors.text, margin: "0 0 16px 0", lineHeight: "1.2" }}>
          Thank you for supporting VerbalFlo
        </h1>
        <p style={{ fontSize: "16px", color: colors.secondaryText, margin: "0 0 8px 0", lineHeight: "1.6" }}>
          Your contribution helps keep VerbalFlo free and continuously improving for everyone.
        </p>
        <p style={{ fontSize: "14px", color: colors.accent, fontWeight: "700", opacity: 0.8 }}>
          Redirecting to home...
        </p>
      </div>

      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

export default SupportSuccessScreen;
